"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    LoginRoute: Symbol("LoginRoute"),
    LoginClient: Symbol("LoginClient"),
    LoginSocialRoute: Symbol("LoginSocialRoute"),
    LoginSocialClient: Symbol("LoginSocialClient"),
    PasswordRecoveryClient: Symbol("PasswordRecoveryClient"),
    PasswordRecoveryRoute: Symbol("PasswordRecoveryRoute"),
    RegisterClient: Symbol("RegisterClient"),
    RegisterRoute: Symbol("RegisterRoute"),
    RoleBatchClient: Symbol("RoleBatchClient"),
    RoleBatchRoute: Symbol("RoleBatchRoute"),
    RoleClient: Symbol("RoleClient"),
    RoleRoute: Symbol("RoleRoute"),
    UserSocialLoginClient: Symbol("UserSocialLoginClient"),
    UserSocialLoginRoute: Symbol("UserSocialLoginRoute"),
    UserClient: Symbol("UserClient"),
    UserRoute: Symbol("UserRoute"),
    PermissionRoute: Symbol("PermissionRoute"),
    PermissionClient: Symbol("PermissionClient"),
    LookupRoute: Symbol("LookupRoute"),
    LookupClient: Symbol("LookupClient"),
    Root: Symbol("Membership-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.LoginSocialRoute).to(_1.LoginSocialRoute);
    bind(TYPES.LoginSocialClient).to(_1.LoginSocialClient);
    bind(TYPES.LoginRoute).to(_1.LoginRoute);
    bind(TYPES.LoginClient).to(_1.LoginClient);
    bind(TYPES.PasswordRecoveryRoute).to(_1.PasswordRecoveryRoute);
    bind(TYPES.PasswordRecoveryClient).to(_1.PasswordRecoveryClient);
    bind(TYPES.RegisterRoute).to(_1.RegisterRoute);
    bind(TYPES.RegisterClient).to(_1.RegisterClient);
    bind(TYPES.RoleBatchRoute).to(_1.RoleBatchRoute);
    bind(TYPES.RoleBatchClient).to(_1.RoleBatchClient);
    bind(TYPES.RoleRoute).to(_1.RoleRoute);
    bind(TYPES.RoleClient).to(_1.RoleClient);
    bind(TYPES.UserSocialLoginRoute).to(_1.UserSocialLoginRoute);
    bind(TYPES.UserSocialLoginClient).to(_1.UserSocialLoginClient);
    bind(TYPES.UserRoute).to(_1.UserRoute);
    bind(TYPES.UserClient).to(_1.UserClient);
    bind(TYPES.PermissionRoute).to(_1.PermissionRoute);
    bind(TYPES.PermissionClient).to(_1.PermissionClient);
    bind(TYPES.LookupRoute).to(_1.LookupRoute);
    bind(TYPES.LookupClient).to(_1.LookupClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
